export const URL_PARAM_APPLICANT_ID = 'applicantId';
export const URL_PARAM_APPLICATION_ID = 'applicationId';
export const URL_PARAM_ASSET_ID = 'assetId';
export const URL_PARAM_CUSTOMER_ID = 'customerId';
export const URL_PARAM_INVITATION_ID = 'invitationId';
export const URL_PARAM_LIABILITY_ID = 'liabilityId';
export const URL_PARAM_APPLICANT_TYPE = 'applicantType';
export const TEAM_VIEW_URL_BASE = `/customer/:${URL_PARAM_CUSTOMER_ID}`;
